import { SitecoreIds } from 'lib/constants';
import { RuleContext } from '../../rules';
import { WhenCondition } from '../../conditions';
import { ConditionRule } from 'lib/reviews/types';
import { RuleConditionData } from '../../serialization';
import { RulesConstants } from 'lib/constants/rules';

export const UserAffiliateConditionId =
  SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.UserAffiliate.ItemId;

export class UserAffiliateCondition<T extends RuleContext> extends WhenCondition<T> {
  userAffiliateId: string;
  constructor(condition: RuleConditionData) {
    super();
    //@ts-ignore allow for extra condition properties
    this.userAffiliateId = condition.userAffiliateId;
  }

  execute(ruleContext: T): boolean {
    const conditions: Array<ConditionRule> =
      (ruleContext.parameters[RulesConstants.Parameters.Conditions] as Array<ConditionRule>) ?? [];
    conditions.push({
      propertyName: 'affiliateId',
      comparison: 'equals',
      value: Number(this.userAffiliateId),
    });
    ruleContext.parameters[RulesConstants.Parameters.Conditions] = conditions;
    return ruleContext.parameters[RulesConstants.Parameters.Operator] ==
      RulesConstants.Operators.And
      ? true
      : false;
  }
}
